import { useMemo, useState } from "react";
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Select as SelectWrapper,
} from "../ui";
import { Input } from "../ui/input";
import { OptionProps, SelectProps } from "./types";

const Select = ({
  options = [],
  onChange,
  placeholder = "Select",
  value,
  searchable = false,
  ...rest
}: SelectProps) => {
  const [search, setSearch] = useState("");

  const filteredOptions = useMemo(() => {
    if (!searchable || !search) return options;

    return options.filter((option) =>
      option.label.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, searchable, options]);

  return (
    <SelectWrapper
      value={value}
      onValueChange={onChange}
      onOpenChange={(open) => {
        if (!open) setSearch("");
      }}
      {...rest}
    >
      <SelectTrigger className="w-full h-[40px] rounded-[4px]">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>

      <SelectContent className="p-0">
        {/* Search (optional) */}
        {searchable && (
          <div className="p-2 border-b">
            <Input
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="h-8"
            />
          </div>
        )}

        {/* Options */}
        <div className="max-h-48 overflow-auto">
          {filteredOptions.length ? (
            filteredOptions.map((option: OptionProps) => (
              <SelectItem
                key={option.value}
                value={option.value}
                disabled={option.disabled}
              >
                {option.label}
              </SelectItem>
            ))
          ) : (
            <div className="px-3 py-2 text-sm text-muted-foreground">
              No results found
            </div>
          )}
        </div>
      </SelectContent>
    </SelectWrapper>
  );
};

export default Select;
